import React from 'react';
import ReactDOM from 'react-dom/client';

/* Ionic CSS - required for IonPage, IonContent, IonApp, IonTabs, etc. */
import '@ionic/react/css/ionic.bundle.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/variables.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
